module.exports = __webpack_public_path__ + "img/chlapacze-przednie-i-tylne.f317c1ce.jpg";